import SignInPage from 'views/SignInPage';
import ForgotPasswordPage from 'views/ForgotPasswordPage';
import ChangePasswordPage from 'views/ChangePasswordPage';

const Routes = [
  {
    path: '/forgot-password',
    name: 'FORGOT-PASSWORD-PAGE',
    component: ForgotPasswordPage,
    exact: true
  },
  {
    path: '/change-password',
    name: 'CHANGE_PASSWORD_PAGE',
    component: ChangePasswordPage,
    exact: false
  },
  {
    path: '/sign-in',
    name: 'SIGN-IN-PAGE',
    component: SignInPage,
    exact: true
  }
];

export default Routes;
